export const executors = [
  {
    name: 'ДРАГУНОВА НАТАЛЬЯ ЛЕОНИДОВНА',
    email: 'ndragunova@gorvodokanal.com',
  },
  {
    name: 'МУП г. Новосибирска ГОРВОДОКАНАЛ',
    email: 'ask@gorvodokanal.com',
  },
  {
    name: 'АЛЕХИНА ЕКАТЕРИНА ВЛАДИМИРОВНА',
    email: 'evalehina@gorvodokanal.com',
  },
  {
    name: 'ЕФРЕМОВА ЕЛЕНА ВЛАДИМИРОВНА',
    email: 'EEfremova@gorvodokanal.com',
  },
  {
    name: 'ВАСИЛЬЕВ ИВАН ОЛЕГОВИЧ',
    email: 'IVasilev@gorvodokanal.com',
  },
  {
    name: 'ДЮЖЕНКОВА ЕЛЕНА ЮРЬЕВНА',
    email: 'EDyuzhenkova@gorvodokanal.com',
  },
  {
    name: 'ЗВЕЗДИНА ИРИНА ВИКТОРОВНА',
    email: 'izvezdina@gorvodokanal.com',
  },
  {
    name: 'ВОЛКОВ АНТОН АЛЕКСАНДРОВИЧ',
    email: 'AVolkov@gorvodokanal.com',
  },
  {
    name: 'Молочная Ю.А. ',
    email: 'YMolochnaya@gorvodokanal.com',
  },
  {
    name: 'Харисова О.А. ',
    email: 'okharisova@gorvodokanal.com',
  },
  {
    name: 'Парбузин К.А',
    email: 'KParbuzin@gorvodokanal.com',
  },
];
